import FilterPanel from '../october/filtrator/filterPanel.js';
import FilterPrice from '../october/filtrator/filterPrice.js';

import Swiper, { Navigation, Pagination, Controller } from 'swiper';
Swiper.use([Navigation, Pagination, Controller]);


// Фикс высоты меню в титульной секции
var titleSection = document.querySelector('.main-selection__wraper');
var mainPageFilter = document.querySelector('.main-selection__form');

mainPageFilter.addEventListener('click focusout', function() {
    let self = this;
    setTimeout(function() {
        let hasOpened = self.classList.contains('main-selection_has-active-dropdown');
        let hasChecked = self.querySelector('.select_has-checked');
        if (hasOpened || hasChecked) {
            const mainPageFilterRect = mainPageFilter.getBoundingClientRect();
            const titleSectionRect = titleSection.getBoundingClientRect();

            let filterTop = mainPageFilterRect.top;
            let blockBottom = titleSectionRect.bottom;

            // mainPageFilter.style.minHeight = blockBottom - filterTop - 20 + 'px';
            mainPageFilter.style.height = blockBottom - filterTop - 20 + 'px';
        } else {
            mainPageFilter.style.height = 'initial';
        }
    }, 0);
});


/*
if (mainPageFilter) {
    // Кастомный эвент, стреляет где-то в libs/dropdown/dropdown.js
    mainPageFilter.addEventListener('open-expanded', function() {
        const mainPageFilterRect = mainPageFilter.getBoundingClientRect();
        const titleSectionRect = titleSection.getBoundingClientRect();

        let filterTop = mainPageFilterRect.top;
        let blockBottom = titleSectionRect.bottom;

        // mainPageFilter.style.minHeight = blockBottom - filterTop - 20 + 'px';
        mainPageFilter.style.height = blockBottom - filterTop - 20 + 'px';
    });

    $(window).on('resize', function() {
        mainPageFilter.dispatchEvent(new Event("open-expanded"));
    });
}
*/
// mainCatalogFilterObserver.observe(targetNode, observerConfig);



//показ на мобиле всех категорий в листинге
[].forEach.call(document.querySelectorAll('.category__list-btn'), function categoryList(el) {
    el.addEventListener('click', function categoryListEl(event) {
        event.currentTarget.style.display="none";
        event.currentTarget.closest('.category').querySelectorAll('.category-card').forEach((item) => {
            item.style.display="flex";
        });
    })
});
//показ на мобиле всех категорий в листинге

//показ на мобиле всех карточек в табе
[].forEach.call(document.querySelectorAll('.about-goals__card-more'), function goalsCard(el) {
    el.addEventListener('click', function goalsCardEl(event) {
        event.currentTarget.style.display="none";
        event.currentTarget.closest('.tab__content-item').querySelectorAll('.about-goals__card:not(.request)').forEach((item) => {
            item.style.display="block";
        });
    })
});
//показ на мобиле всех карточек в табе

//показ на мобиле всех карточек в blog
[].forEach.call(document.querySelectorAll('.blog-list__btn-more'), function listBtn(el) {
    el.addEventListener('click', function listBtnEl(event) {
        event.currentTarget.style.display="none";
        event.currentTarget.closest('.blog-list').querySelectorAll('.category-card').forEach((item) => {
            item.style.display="flex";
        });
    })
});
//показ на мобиле всех карточек в blog

//слайдер отзывов
let reviewsVideoSlider = new Swiper(".main-reviews__slider.video .main-reviews__list", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    navigation: {
        nextEl: ".main-reviews__slider-next",
        prevEl: ".main-reviews__slider-prev",
    },
    on: {
        'init': swiper => {
            swiper.el.dispatchEvent(new CustomEvent('swiperInit'));
        }
    }
});
let reviewsAudioSlider = null;
function reviewsAudioSliderInit() {
    reviewsAudioSlider = new Swiper(".main-reviews__slider.audio .main-reviews__list", {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        pagination: {
            el: ".main-reviews__slider .main-reviews__slider-pagination",
            clickable: true,
        },
        breakpoints: {
            300: {
                pagination: {
                    el: ".main-reviews__slider-mobile .main-reviews__slider-pagination",
                    clickable: true,
                },
            },
            768: {
                pagination: {
                    el: ".main-reviews__slider .main-reviews__slider-pagination",
                    clickable: true,
                },
            }
        },

    });

    reviewsVideoSlider.controller.control = reviewsAudioSlider;
    reviewsAudioSlider.controller.control = reviewsVideoSlider;
}
window.addEventListener("resize", function resize(){
    reviewsAudioSliderInit()
});
window.addEventListener("load", function load(){
    reviewsAudioSliderInit()
});
//слайдер отзывов
//слайдер отзывов phone
let reviewsPhoneSlider = new Swiper(".reviews-phone__slider", {
    slidesPerView: 5,
    spaceBetween: 60,
    loop: true,
    navigation: {
        nextEl: ".reviews-phone__slider-next",
        prevEl: ".reviews-phone__slider-prev",
    },
    breakpoints: {
        300: {
            slidesPerView: 1,
            spaceBetween: 20,
        },
        768: {
            slidesPerView: 3,
            spaceBetween: 60,
        },
        950: {
            slidesPerView: 4,
        },
        1171: {
            slidesPerView: 5,
        }
    },

});
//слайдер отзывов phone

//hover founder
[].forEach.call(document.querySelectorAll('.founder__item'), function founderItem(el) {
    el.addEventListener('click', function founderItemEl(event) {
        document.querySelectorAll('.founder__item').forEach((item) => {
            item.classList.remove('active')
        });
        event.currentTarget.classList.add('active');
    })
});
//hover founder


// Пееренос значения цены в плейсхолдер

let priceSelect = document.querySelector('.main-selection__select.price');
let priceInputs = priceSelect.querySelectorAll('input');

let pricePlaceholderBlock = priceSelect.querySelector('.select__range-placeholder-block');
let pricePlaceholderMin = priceSelect.querySelector('.range-val-min');
let pricePlaceholderMax = priceSelect.querySelector('.range-val-max');
let pricePlaceholderDelimiter = priceSelect.querySelector('.select__range-placeholder-del');
let currentMinMax = {
    min: '',
    max: '',
};

priceInputs.forEach((input, idx) => {
    input.addEventListener('change', function() {

        if (idx == 0) {
            currentMinMax.min = parseFloat(this.value.replace(' ', ''));
        }

        if (idx == 1) {
            currentMinMax.max = parseFloat(this.value.replace(' ', ''));
        }

        updatePricePlaceholders();
    });
});

function updatePricePlaceholders() {
    pricePlaceholderBlock.classList.remove('shown');
    pricePlaceholderMin.classList.remove('shown');
    pricePlaceholderMax.classList.remove('shown');
    pricePlaceholderDelimiter.classList.remove('shown');

    if (currentMinMax.max > 0) {
        pricePlaceholderBlock.classList.add('shown');
        pricePlaceholderMin.classList.add('shown');
        pricePlaceholderMax.classList.add('shown');
        pricePlaceholderDelimiter.classList.add('shown');
        pricePlaceholderMax.innerHTML = formatPrice(currentMinMax.max);

        if (currentMinMax.min > 0) {
            pricePlaceholderMin.innerHTML = formatPrice(currentMinMax.min);
        } else {
            pricePlaceholderMin.innerHTML = 0;
        }

    } else if (currentMinMax.min > 0) {
        pricePlaceholderBlock.classList.add('shown');
        pricePlaceholderMin.classList.add('shown');
        pricePlaceholderMin.innerHTML = formatPrice(currentMinMax.min);
    }
}

var lastCurrency = 'rub';
$('.currency-selector__input').on('click', function(e) {
    let fromMaps = {
        1: 'usd',
        2: 'eur',
        3: 'rub',
    }

    let curentCurrency = fromMaps[$(this).val()];

    convertCurrencyInInput(lastCurrency, curentCurrency);
    lastCurrency = curentCurrency;
});


function convertCurrencyInInput(from, to) {
    let values = [
        currentMinMax.min,
        currentMinMax.max,
    ];

    /*
    let newState;
    newState[self.slug] = [0,0];

    if (!isNaN(self.max) && self.max > 0) {
        newState[self.slug][0] = 0;
        newState[self.slug][1] = self.max;
    }

    if (!isNaN(self.min) && self.min > 0) {
        newState[self.slug][0] = self.min;
    }*/

    $('body').request('apiVue::onConvertCurrency', {
        data: {
            'from_currency': from,
            'to_currency': to,
            'mode': 'value',
            'array': values,
        },
        success: function(response) {
            priceInputs.forEach((input, idx) => {
                if (idx == 0) {
                    input.value = formatPrice(Math.round(response.array[0], -3));
                }

                if (idx == 1) {
                    input.value = formatPrice(Math.round(response.array[1], -3));
                }
            });

            currentMinMax = {
                min: response.array[0] ?? '',
                max: response.array[1] ?? '',
            };

            updatePricePlaceholders();
        },
        error: function(response) {

            if (response.statusText != 'abort') {
                console.log('ERROR onGetEstatesPreviews');
                console.log(response);
            }
        }
    });
}

function formatPrice(priceRaw, isPlaceholder = false) {
    let price = Number.parseFloat(  priceRaw );
    price = Math.round(price, -3);

    if (isNaN(price) || price == 0) return isPlaceholder ? 0 : '';

    return price.toLocaleString()
}

/*
function applyFilterOnMainPage(event) {
    event.preventDefault();
    if (document.querySelector('.main-selection_has-active-dropdown')) return;

    if(event.target.closest('form')) {
        const form = event.target.closest('form');
        const groups = form.querySelectorAll('[data-group-id]');
        groups.forEach(group => {
            form.querySelector(`#${group.dataset.groupId}`).checked = !!group.querySelectorAll('input:checked').length;
        })
    }
    let sEstateTypeSlug = 'live';
    if(document.querySelector('.estate_type input:checked')) {
        sEstateTypeSlug = document.querySelector('.estate_type input:checked').value;
    }

    // анализируем форму фильтра и пишем в адресную строку примененые фильтры
    // цена
    const obFilterPrice = new FilterPrice();
    obFilterPrice.run();

    // обычные опции
    const obFilterPanel = new FilterPanel();
    obFilterPanel.run();
    window.location = '/catalog/' + sEstateTypeSlug + '/' + window.location.search;
}
*/

let timeoutCounter;
mainPageFilter.addEventListener('click', function() {
    if (timeoutCounter) clearTimeout(timeoutCounter);

    timeoutCounter = setTimeout(function() {
        loadMinMaxPrice();
    }, 300);
});

function loadMinMaxPrice() {
    if (document.querySelector('.main-selection_has-active-dropdown')) return;

    let groups = mainPageFilter.querySelectorAll('[data-group-id]');
    groups.forEach(group => {
        mainPageFilter.querySelector(`#${group.dataset.groupId}`).checked = !!group.querySelectorAll('input:checked').length;
    })

    let sEstateTypeSlug = 'live';
    if(document.querySelector('.estate_type input:checked')) {
        sEstateTypeSlug = document.querySelector('.estate_type input:checked').value;
    }

    const obFilterPrice = new FilterPrice();
    obFilterPrice.run();

    const obFilterPanel = new FilterPanel();
    obFilterPanel.run();

    let sQuery = window.location.search;

    const searchParams = new URLSearchParams(sQuery.substring(sQuery.indexOf('?')));

    let query = {
        country: searchParams['property[location-1]'],
        currency: searchParams['property[price-currency]'],
        price: searchParams['property[price-value]'],
        announcement_type: searchParams['property[announcement_type]'],
        estate_type: sEstateTypeSlug,
    }

    $('body').request('apiVue::onGetCurrencyMinMaxWithQueryVer2', {
        data: query,
        success: function(response) {

            priceInputs.forEach((input, idx) => {
                if (idx == 0) {
                    input.placeholder = formatPrice(response.min, true);
                }

                if (idx == 1) {
                    input.placeholder = formatPrice(response.max, true);
                }
            });
        },
        error: function(response) {

            if (response.statusText != 'abort') {
                console.log('ERROR onGetEstatesPreviews');
                console.log(response);
            }
        }
    });
}
